export const SERVER_URL = "https://solvecard.net/api/";
